<template>
  <v-card flat class='grey lighten-4' height='100%' >
    <request-status :request='req' />
    <request-status :request='statementRequest' :message200='false' />
    <!-- {{computedInvoice}} -->
    <!-- {{clientId}}|{{relationshipId}} -->
    <!-- pid: {{practitionerId}} | meId: {{meId}} -->
    <v-card-title class='py-0 px-1' >
      <v-chip label v-if='practitionerId' >{{ getPractitionerById(practitionerId).full_name }}
      </v-chip>
      <v-spacer/>
      <v-btn
        v-if='!success'
        small color='primary'
        @click='create'
        :disabled='statementRequest.loading || !hasCreateInvoicePermissions || !metaIsValid || !hasAppointments'
        :loading='req.loading' >
        Create invoice
      </v-btn>
    </v-card-title>
    <template v-if='title' >
      <v-card-title class='overline grey lighten-4 py-0' >
        <v-btn small icon class='ml-1 pl-0' >
          <v-icon small >post_add</v-icon>
        </v-btn>
        {{title}}
        <v-spacer></v-spacer>
        <v-btn @click='$emit("close")' icon small >
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
    </template>
    <!-- <v-divider /> -->
    <!-- <pre v-text='computedInvoice' /> -->
    <invoice-success
      v-if='success'
      v-model='remoteInvoice'
      v-on='$listeners' />
    <template v-else >
      <invoice-billing-details
        class='ma-2 elevation-2'
        v-if='statementRequest && hasCreateInvoicePermissions'
        :expanded='false'
        :request='statementRequest'
        :settings.sync='spaceSettings'
        @update:settings='setSpaceSettings' />
      <v-divider/>
      <!-- S:<pre v-text="statement" /> -->

      <v-card-text class='pb-0 pt-0' >
        <v-text-field
          label='Invoice name'
          class='pb-0 mb-0' v-model='invoice.title' >
        </v-text-field>
        <v-layout wrap>
          <v-flex xs6>
            <v-dialog
              ref="dialog"
              v-model="showDatepicker"
              persistent lazy full-width width="290px" >

              <v-text-field
                slot="activator"
                class='pb-0 mb-0 mr-2'
                label='Invoice date' readonly
                append-icon='event'
                v-model='invoice.date' >
              </v-text-field>
              <v-card>
                <v-date-picker flat tile no-title class="elevation-0"
                  v-model="invoice.date"
                  @input='showDatepicker=false' scrollable >
                </v-date-picker>
                <v-card-actions >
                  <v-btn @click='showDatepicker=false' flat >Done</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
          <v-flex xs6 >
            <v-dialog
              ref="dialog"
              v-model="showDueDatepicker"
              persistent lazy full-width width="290px" >

              <v-text-field
                slot="activator"
                class='pb-0 mb-0'
                label='Invoice due date' readonly
                append-icon='event'
                v-model='invoice.due_date' >
              </v-text-field>
              <v-card>
                <v-date-picker flat no-title class='elevation-0'
                  v-model="invoice.due_date"
                  :min='invoice.date'
                  @input='showDueDatepicker=false' scrollable >
                </v-date-picker>
                <v-card-actions >
                  <v-btn @click='showDueDatepicker=false' flat >Done</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-flex>
          <v-alert outline dismissible class='pa-1 ma-0 caption'
            v-if='invoice.due_date < latestDate'
            :value='true' type='warning' >
            You have selected a due date earlier than the latest appointment included on this invoice<br/>
            <strong>You can still create the invoice, we just wanted to let you know</strong>
          </v-alert>
        </v-layout>
      </v-card-text >

      <v-list
        v-if='hasAppointments'
        class='ma-0' dense three-line >
        <v-list-group >
          <v-subheader class='overline' slot='activator' >
            <v-icon small class='mr-2' >person</v-icon>
            {{ fullname }}
          </v-subheader>
          <client-card v-if='relationshipId'
            class='ma-0 pa-0' flat
            :with-client-name='false'
            :relationship-id='relationshipId'
            @relationship='setRelationship' />
        </v-list-group>
        <v-divider></v-divider>

        <v-list-group >
          <v-subheader slot='activator' class='overline' >
            <v-icon small v-if='password' class='mr-2' color='amber' >lock</v-icon>
            <v-icon small v-else class='mr-2' color='info' >lock_open</v-icon>
            Password protect
          </v-subheader>
          <encrypt-invoice
            :password.sync='password'
            :password-hint.sync='passwordHint'
            :relationship='rel' />
        </v-list-group>
        <v-divider />

        <read-only-statement-list flat debounce
            v-if='computedInvoice && computedInvoice.appointments'
            v-model='statementRequest'
            :initially-collapsed="true"
            :due.sync='finaldue'
            :with-edit="withEdit"
            :appointment-ids='computedInvoice.appointments'
            @edit="editInvoiceDetails"
            @remove="removeAppointment" />

        <v-divider></v-divider>

        <template v-if='finaldue && finaldue > 0' >
          <div class='px-3 mb-3' >
            <v-checkbox v-model='markPaid' class='caption' label='Mark as paid' hide-details dense />
            <payment-method-picker small v-if='markPaid' v-model='paymentMethod' />
          </div>
        </template>

      </v-list>
      <!-- <pre class="caption" >
        {{relationship}}
      </pre> -->
      <template v-if='ready' >
        <transition name="delay-display-none" >
          <v-alert
            v-if='!metaIsValid'
            type='warning' class='pa-1 my-0' dense :value='true' >
            Some information required to create an invoice is missing.
            <v-btn @click='fetchMeta' :loading='requests.relationship.loading || requests.appt.loading' >Fetch data from server</v-btn>
          </v-alert>
        </transition>
      </template>

      <div v-if='!hasAppointments' class='warning--text caption px-3' >
        <v-icon class='warning--text' small>warning</v-icon>
        No appointments selected
      </div>

      <v-card-actions :class='mobileCardActionsClasses' :style='mobileCardActionsStyles' >
      <!-- <v-bottom-navigation fixed  > -->
        <v-btn
          @click='create'
          :disabled='statementRequest.loading || !hasCreateInvoicePermissions || !metaIsValid || !hasAppointments'
          :loading='req.loading' block color='primary' >
          Create Invoice
        </v-btn>
      </v-card-actions>

      <v-alert :value='!hasCreateInvoicePermissions' >
        You do not have permission to create invoices in this space or spaces
      </v-alert>
    </template>
    <!-- <pre v-text='computedInvoice' /> -->
    <!-- <v-dialog fullscreen
      v-if="withEdit"
      v-model="editAppointmentDialog" >
      <invoice-details v-if="selectedAppointment && editAppointmentDialog"
        v-model="selectedAppointment"
        :with-create="false"
        @close="editAppointmentDialog=false" />
    </v-dialog> -->
  </v-card>
</template>

<script>

import ReadOnlyStatementList from '@/components/lists/ReadOnlyStatementList.vue'
import EncryptInvoice from '@/components/invoice/manage/create/encrypt.vue'
import InvoiceSuccess from './success'
import ClientCard from '@/components/client/ClientCard'
import InvoiceBillingDetails from '../InvoiceBillingDetails.vue'
import PaymentMethodPicker from '@/components/pickers/PaymentMethodPicker.vue'
// import InvoiceDetails from '@/components/appointment/edit/InvoiceDetails'

import {DateTime} from 'luxon'
import {mapGetters} from 'vuex'
import Vue from 'vue'

export default {
  name: 'ConfirmInvoice',
  components: {
    InvoiceBillingDetails,
    ReadOnlyStatementList,
    ClientCard,
    InvoiceSuccess,
    EncryptInvoice,
    PaymentMethodPicker
    // InvoiceDetails
  },
  props: {
    title: { type: String },
    value: { type: Object, default: () => {} },
    relationship: { type: Object, default: () => {} },
    appointments: { type: Array, default: () => { return [] } },
    touch: { type: Number, default: 0 },
    withEdit: { type: Boolean, default: false }
  },
  data () {
    return {
      // relationship: {}, // temporary
      ready: false,
      success: false,
      finaldue: 0,
      markPaid: false,
      paymentMethod: null,
      editAppointmentDialog: false,
      selectedAppointment: null,
      invoice: {
        title: null,
        due_date: null,
        date: null,
        appointments: [],
        appointment_data: []
      },
      spaceSettings: {},
      statementRequest: {},
      req: {
        resource: 'invoiceguru.invoices'
      },
      requests: {
        relationship: { resource: 'ag.spaces.relationships' },
        appt: { resource: 'ag.practitioner.appointments' }
      },
      rel: {},
      password: null,
      passwordHint: null,
      showDatepicker: false,
      showDueDatepicker: false
    }
  },
  mounted () {
    let vm = this
    window.setTimeout(() => { vm.ready = true }, 5000) // if it takes more than 5 seconds, force ready to try
  },
  watch: {
    // computedInvoice () {
    //   this.$emit('input', this.invoice)
    // },
    computedTitle () {
      Vue.set(this.invoice, 'title', this.computedTitle)
    },
    latestDate () {
      if (this.latestDate > this.invoice.date) {
        this.invoice.due_date = this.latestDate
      }
    },
    invoiceDate () {
      if (this.invoiceDate > this.invoice.due_date) {
        this.invoice.due_date = this.invoiceDate
      }
    },
    requestStatus () {
      if (this.requestStatus === 201) {
        this.success = true
        this.$emit('success', this.remoteInvoice)
      }
    },
    touch () {
      this.reset()
    },
    loading () {
      if (this.loading === true) { this.ready = false }
      if (this.loading === false) {
        let vm = this
        window.setTimeout(() => { vm.ready = true }, 1500)
      }
    }
  },
  methods: {
    reset () {
      this.invoice = {
        title: null,
        due_date: null,
        date: null,
        appointments: [],
        appointment_data: []
      }
      this.password = null
      this.passwordHint = null
      if ('space_id' in this.invoice) { delete this.invoice.space_id }
      this.success = false
    },
    create () {
      let payload = this.computedInvoice
      this.$emit('creating', payload)
      this.req.data = payload
      this.$request('save', this.req)
    },
    editInvoiceDetails (appointment) {
      this.selectedAppointment = appointment
      this.editAppointmentDialog = true
    },
    removeAppointment (appointment) {

    },
    setSpaceSettings (settings) {
      if (settings && settings.service_id) {
        Vue.set(this.invoice, 'space_id', settings.service_id)
      }
    },
    setRelationship (rel) {
      this.rel = rel
    },
    fetchMeta () {
      if (this.relationshipId) {
        this.requests.relationship.resourceId = this.relationshipId
        return this.$request('get', this.requests.relationship)
      }
      if (this.sortedAppointmentIds && this.sortedAppointmentIds.length > 0) {
        this.requests.appt.resourceId = this.sortedAppointmentIds[0]
        return this.$request('get', this.requests.appt)
      }
    }
  },
  computed: {
    ...mapGetters(['getPractitionerById']),
    spaceIds () {
      let ids = []
      let space = this.getObjectPath(this.statementRequest, 'result.invoice.settings.space')
      let spaces = this.getObjectPath(this.statementRequest, 'result.invoice.settings.spaces')
      if (space) { ids.push(space) }
      if (spaces && spaces.length > 0) {
        ids = ids.concat(spaces)
      }
      if (ids && ids.length > 0) {
        return ids.map((space) => { return space.service_id })
      }
      return ids
    },
    loading () {
      if (this.req.loading === true) { return true }
      if (this.statementRequest.loading === true) { return true }
      return false
    },
    selectedSpaceId () {
      return this.getObjectPath(this.spaceSettings, 'service_id')
    },
    fullname () {
      if (this.relationship && this.relationship.id) {
        return this.formatFullName(this.relationship)
      } else {
        return this.formatFullName(this.rel)
      }
    },
    computedTitle () {
      let name = this.formatFullName(this.relationship)
      if (this.invoice && this.invoice.date) {
        name = this.fullname + ' - ' + this.invoice.date
      }
      return name
    },
    sortedAppointments () {
      if (this.appointments && this.appointments.length > 0) {
        return this.appointments.sort((a, b) => {
          if (a.start_time > b.start_time) { return 1 }
          if (a.start_time < b.start_time) { return -1 }
          return 0
        })
      }
      return []
    },
    hasCreateInvoicePermissions () {
      if (this.req.loading) { return true }
      // insufficient
      if (this.spaceIds && this.spaceIds.length > 0) {
        return this.permissionsCanCreateInvoiceMethod(this.spaceIds, this.appointments)
      }
      return true
      // return (this.spaceIds && this.spaceIds.length > 0 && this.permissionsCanCreateInvoice === false)
    },
    requestStatus () {
      return this.req.status
    },
    passwordWatchString () {
      return this.password + this.passwordHint
    },
    relIdNumber () {
      return this.getObjectPath(this.rel, 'record.medical_aid.patient_id_number')
    },
    relEmail () {
      let email = this.getObjectPath(this.rel, 'client.email')
      if (this.isRealEmail(email)) { return email }
      return null
    },
    relPhone () {
      return this.getObjectPath(this.rel, 'client.phone_number')
    },
    invoiceDate () {
      return this.invoice.date
    },
    sortedAppointmentIds () {
      return this.sortedAppointments.map((a) => { return a.id })
    },
    practitionerId () {
      return this.meId
      // if (this.sortedAppointments && this.sortedAppointments.length > 0) {
      //   let appt = this.sortedAppointments[0]
      //   if (appt.practitioner_id) { return appt.practitioner_id }

      //   if (appt.practitioner) {
      //     if (isNaN(appt.practitioner)) {
      //       return appt.practitioner.id
      //     } else {
      //       return appt.practitioner
      //     }
      //   }
      // }
      // return this.meId
    },
    relationshipId () {
      let relId = this.getObjectPath(this.relationship, 'id', null)
      if (!relId && this.clientId) {
        let rel = this.getRelationByClientId(this.clientId)
        if (rel && rel.id) { return rel.id }
      }
      if (this.appointments && this.appointments.length > 0) {
        let appt = this.appointments[0]
        if (appt && appt.computed_relationship_id) { return appt.computed_relationship_id }
      }
      return relId
    },
    remoteClientId () {
      let id = this.getObjectPath(this.requests, 'relationship.result.client.id', null)
      if (!id) {
        id = this.getObjectPath(this.requests, 'appt.result.client.id', null)
      }
      return id
    },
    clientId () {
      let id = this.getObjectPath(this.rel, 'client.id', null)
      if (id) { return id }
      id = this.getObjectPath(this.relationship, 'user_id', null)
      if (id) { return id }
      if (this.remoteClientId) { return this.remoteClientId }
      return null
    },
    metaIsValid () {
      // && this.relationshipId
      if (this.clientId) { return true }
      return false
    },
    remoteInvoice () {
      return this.getObjectPath(this.req, 'result', {})
    },
    computedInvoice () {
      if (!this.invoice.date) {
        this.invoice.date = DateTime.local().toISODate()
      }
      if (!this.invoice.due_date) {
        this.invoice.due_date = this.latestDate
      }
      if (!this.invoice.title) {
        this.invoice.title = this.computedTitle
      }
      let data = {
        appointments: this.sortedAppointmentIds,
        appointment_data: this.sortedAppointments,
        relationship_id: this.relationshipId,
        practitioner_id: this.practitionerId,
        customer_id: this.clientId,
        title: this.invoice.title,
        date: this.invoice.date,
        due_date: this.invoice.due_date,
        invoice_period_from: this.firstDate,
        invoice_period_to: this.latestDate
        // status: 'paid',
        // payment_method: 'eft'
      }
      if (this.selectedSpaceId) {
        data['space_id'] = this.selectedSpaceId
      }
      if (this.password) {
        data.encrypt_password = this.password
        if (this.passwordHint) { data.encrypt_password_hint = this.passwordHint }
      }
      if (this.finaldue > 0 && this.markPaid === true) {
        data.status = 'paid'
        if (this.paymentMethod) { data.payment_method = this.paymentMethod }
      }
      return data
    },
    firstDate () {
      if (this.hasAppointments) {
        return DateTime.fromISO(this.sortedAppointments[0].start_time).toISODate()
      }
      return null
    },
    latestDate () {
      if (this.hasAppointments) {
        let lastAppt = this.sortedAppointments[this.sortedAppointments.length - 1]
        return DateTime.fromISO(lastAppt.start_time).toISODate()
      }
      return null
    },
    numAppointments () {
      if (this.hasAppointments) {
        return this.sortedAppointments.length
      }
      return 0
    },
    hasAppointments () {
      if (this.sortedAppointments && this.sortedAppointments.length > 0) {
        return true
      }
      return false
    },
    total () {
      if (this.invoice && this.invoice.appointment_data) {
        return this.invoice.appointment_data.reduce((total, appt) => {
          return total + parseFloat(appt.price)
        }, 0)
      }
      return 0
    }
  },
  i18n: {
    messages: {
      en: {
        numAppointments: '{count} appointment|{count} appointments'
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// confirm.vue?8d9d11de